import React, { Component } from 'react';
import _, { isEmpty } from 'lodash';
import { includes } from 'lodash';
import * as HTML_RENDITION from '../../utils/general/general';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { RenditionLoadable } from '../../utils/general/LoadableRelated';
import {isStaticMode, isHTMLLightRendition, base64urlEncode} from '../../utils/general/general';
import commonStore from '../../store/commonStore';
import cvIcon from  '../../../style/img/cvLogo.svg';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';

// Important!!! Some of part show frequent, So please not use react-loadable dynamic load.
// Because too many request send when page open are also bad, You can change below load logic if need
import AuthorList from './authorList/authorList';

// This part will always show when default
// import CarouselCampaigns from './carouselCampaigns';

const Multicompany = RenditionLoadable({
    loader: () => import('./multicompany'),
}, "multicompany", Date.now());

import FinancialsBlock from './financialsBlockRelated/financialsBlock';

const RegionBar = RenditionLoadable({
    loader: () => import('./regionBar'),
}, "regionBar", Date.now());

const GlobaliserEditions = RenditionLoadable({
    loader: () => import('./globaliserEditions'),
}, "globaliserEditions", Date.now());

import WhatsTrending from './whatsTrending';
import RelatedResearch from './RelatedResearch';
// import StacksCustom from './stacksCustom';
import ErrorBoundary from '../../utils/api/errorBoundary';
import CarouselCampaignsOldBranding from './carouselCampaignsOldBranding';
import CarouselEventsOldBranding from './carouselEventsOldBranding';
import RenditionUrlGenerator from '../../utils/api/renditionUrlGenerator';

const CitiSBestPeriodicalBar = RenditionLoadable({
    loader: () => import('./citiSBestPeriodicalBar'),
}, "citiSBestPeriodicalBar", Date.now());

const CarouselEvents = RenditionLoadable({
    loader: () => import('./carouselEvents'),
}, "carouselEvents InfoPane", Date.now());

interface IInfoPaneProps {
    source?: any;
    docHeaderSectionJson: any;
    platformIdData: any,
    initialData: any;
    showOldBranding: boolean;
    analystSubscriptionData: any;
}

export class InfoPane extends Component<IInfoPaneProps, any> {
    public CAMPAIGNS: any;
    public CAMPAIGNS_DEFAULT: any;
    public EVENTS: any;
    public WHATSTRENDING_RESEARCH: any;

    constructor(props: IInfoPaneProps) {
        super(props);
        this.CAMPAIGNS = React.createRef();
        this.CAMPAIGNS_DEFAULT = React.createRef();
        this.EVENTS = React.createRef();
        this.WHATSTRENDING_RESEARCH = React.createRef();
    }

    public showCampaigns() {
        return !HTML_RENDITION.isAuthPreview() && this.props.docHeaderSectionJson!.issuerPage!.financialsBlock!.showCampaigns == "true";
    }

    public isPoint() {
        return window.HTML_RENDITION.isPoint;
    }

    public showPreviousEditions() {
        if (this.props.initialData.productType == "globaliser" || window.HTML_RENDITION.isPoint) {
            return this.props.docHeaderSectionJson.metadata.productType == 'Globaliser';
        } else if (window.HTML_RENDITION.isRoundup || window.HTML_RENDITION.isGlobalizer) {
            if (this.props.initialData.periodicalId == '' || this.props.initialData.periodicalId == 'null' || _.isUndefined(this.props.initialData.periodicalId)) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    }

    public showCitiSBestPeriodicalBar() {
        return this.props.docHeaderSectionJson.metadata.showFLS && this.props.initialData.urlParameters['citis_best'] == 'true';
    }

    public showEvents() {
        return !HTML_RENDITION.isAuthPreview() && HTML_RENDITION.parseToBoolean(this.props.docHeaderSectionJson?.issuerPage?.financialsBlock?.showEvents);
    }

    public showWhatsTrending() {
        const { initialData } = this.props;
        const showWhatsTrending: boolean = !HTML_RENDITION.isAuthPreview() && !initialData.isStaticHtmlExport && !initialData.isPublic && !initialData.html_light_rendition;
        return showWhatsTrending;
    }

    public showRelatedResearch() {
        const { initialData } = this.props;
        const showRelatedResearch: boolean = !HTML_RENDITION.isAuthPreview() && !initialData.isStaticHtmlExport && !initialData.isPublic;
        return showRelatedResearch;
    }

    public ifShowResearchStacks() {
        const { docHeaderSectionJson, initialData } = this.props;
        let showRecommended: boolean = false;
        const showPopular: boolean = initialData.isEntitled('POPULAR');
        if (initialData.isEntitled('RECOMMENDED')) {
            if (HTML_RENDITION.isPreview()) {
                showRecommended = false;
            } else {
                showRecommended =  (docHeaderSectionJson.issuerPage && docHeaderSectionJson.issuerPage.financialsBlock
                    && docHeaderSectionJson.issuerPage.financialsBlock.showRecommended && docHeaderSectionJson.issuerPage.financialsBlock.showRecommended == 'true');
            }

        }
        const configShowRec = (window.HTML_RENDITION.initialData.recommendedSectionShow || 'true') === 'true';
        showRecommended = showRecommended && configShowRec;
        const showResearchStacks: boolean = showRecommended || showPopular;
        return {
            showRec: showRecommended,
            showPop: showPopular,
            showStacks: showResearchStacks
        };
    }

    public checkCurrentCompoentDOMEntit() {
        this.CAMPAIGNS.current && checkDomEntitlement(this.CAMPAIGNS.current);
        this.CAMPAIGNS_DEFAULT.current && checkDomEntitlement(this.CAMPAIGNS_DEFAULT.current);
        this.EVENTS.current && checkDomEntitlement(this.EVENTS.current);
        this.WHATSTRENDING_RESEARCH.current && checkDomEntitlement(this.WHATSTRENDING_RESEARCH.current);
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
    }

    public render() {
        
        if (isStaticMode()) {
            return null;
        }

        const { initialData, docHeaderSectionJson, showOldBranding, analystSubscriptionData, platformIdData } = this.props;
        const { productType } = initialData;
        const { publishingGroup, productFocus } = docHeaderSectionJson.metadata;
        const isEquitiesMultiCompany = initialData.isFAVE && publishingGroup == 'CIR' && productFocus == 'MULTICOMPANY';
        const isOffTheCuffPreview = productType === 'blog' && initialData.mode === 'preview_mode';
        const multiComapnyShow = !docHeaderSectionJson.metadata.isDiscontinueCoverage && (productType?.toLowerCase() === 'multicompany' || isEquitiesMultiCompany);
        const financialBlockShow = !docHeaderSectionJson.metadata.isDiscontinueCoverage && !initialData.isNonRSCH && !isOffTheCuffPreview;
        const menuCode = commonStore.getState().commonStateReducer.menuCode;
        const environment = window.HTML_RENDITION.initialData.environment;
        const url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + "/cv2/go/RSCH_LANDING_PAGE/" +base64urlEncode('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/all_research');
        return (
            
            <div className="paneInnerFrame">
                <span id="infoPaneContent" className="paneContent">

                    {((isEmpty(menuCode) && includes(platformIdData, window.HTML_RENDITION.initialData.platform)) || ((menuCode !== "RSCH_LANDING_PAGE") && !isEmpty(menuCode))) &&
                    <div><button className='topRightButton' onClick={()=>{
                        window.open(url);
                        RSCH_HTML_TRACKING_CONFIG.trackReadMoreClick();
                        }}>Read more Citi Research
                    <img className ="iconHeight" src={cvIcon} alt="icon"/>
                    </button></div>
                    }


                    {!window.HTML_RENDITION.isPoint &&
                        <AuthorList showOldBranding={showOldBranding} mainSource={docHeaderSectionJson} source={docHeaderSectionJson.authors} editor={docHeaderSectionJson.i18n.authorEditor}
                            teamDirectoryUrl={initialData.new_team_directory_url} bookMeetingUrl={initialData.new_book_meeting_url} analystSubscriptionData={analystSubscriptionData}/>
                    }
                    {(multiComapnyShow || financialBlockShow) && (<div className='section-area'>
                        {!showOldBranding && multiComapnyShow && <Multicompany showOldBranding={showOldBranding} />}
                        {!showOldBranding && financialBlockShow && <div id="financialsBlock">
                                <FinancialsBlock showOldBranding={showOldBranding} />
                            </div>}
                         {showOldBranding && !docHeaderSectionJson.metadata.isDiscontinueCoverage && (productType?.toLowerCase() === 'multicompany' || isEquitiesMultiCompany) &&
                            <Multicompany showOldBranding={showOldBranding} />
                        }
                        {showOldBranding && !docHeaderSectionJson.metadata.isDiscontinueCoverage &&
                        !initialData.isNonRSCH &&
                        !isOffTheCuffPreview &&
                            <div id="financialsBlock">
                                <FinancialsBlock showOldBranding={showOldBranding} />
                            </div>
                        } 
                    </div>)}
                    {this.isPoint() &&
                        <div id="regionBar" data-entitlement="CAMPAIGNS" ref={this.CAMPAIGNS}>
                            <RegionBar />
                        </div>
                    }
                    {this.showPreviousEditions() &&
                        <div id="editionsBar">
                            <GlobaliserEditions />
                        </div>
                    }
                    {this.showCitiSBestPeriodicalBar() &&
                        <div id="citiSBestPeriodicalBar">
                            <ErrorBoundary><CitiSBestPeriodicalBar /></ErrorBoundary>
                        </div>
                    }
                    {
                    /*
                        !initialData.isStaticHtmlExport && !initialData.isPublic && !isOffTheCuffPreview &&
                        <div id="another_campaigns_contain">
                            <div data-entitlement="CAMPAIGNS" tabIndex={0} ref={this.CAMPAIGNS_DEFAULT} id="campaigns_default">
                                <CarouselCampaigns showDefaultImg={true} />
                            </div>
                        </div>
                    */
                    }
                    {!showOldBranding && !initialData.isStaticHtmlExport && !isOffTheCuffPreview && this.showEvents() &&
                        <div data-entitlement="EVENTS" ref={this.EVENTS}>
                            {/* showUncomingEvent judgement inside CarouselEvents.Because it should add a new action and mapToProps, add in here will cause too much component reRender*/}
                            <CarouselEvents showDefaultImg={true}/>
                        </div>
                    }
                    { !isOffTheCuffPreview && this.showRelatedResearch() && !showOldBranding && !isHTMLLightRendition() && <RelatedResearch  showOldBranding={showOldBranding}/> }
                    { !showOldBranding && !isOffTheCuffPreview && this.showWhatsTrending() && !isHTMLLightRendition() && <WhatsTrending  showOldBranding={showOldBranding}/> }
                    
                    {showOldBranding && this.showCampaigns() &&
                        <div id="campaigns_contain" tabIndex={0} style={{ display: 'block' }}> {/* After you change carouselCampaigns related code, style={{ display: 'block' }} should remove*/}
                            <div data-entitlement="CAMPAIGNS" id="campaigns" className="infiniteCarousel" ref={this.CAMPAIGNS}>
                                <CarouselCampaignsOldBranding showDefaultImg={false} />
                            </div>
                        </div>
                    }
                    {/* {!initialData.isStaticHtmlExport && !initialData.isNonRSCH && !isOffTheCuffPreview &&
                     this.ifShowResearchStacks().showStacks && // should move ifShowResearchStacks() function relate logic(in old rendition stacks-directive.js) to this file
                        <StacksCustom showRec={this.ifShowResearchStacks().showRec} showPop={this.ifShowResearchStacks().showPop} showOldBranding={showOldBranding} />
                    } */}
                    {showOldBranding && !initialData.isStaticHtmlExport && !initialData.isPublic && !isOffTheCuffPreview &&
                    <div id="another_campaigns_contain">
                        <div data-entitlement="CAMPAIGNS" tabIndex={0} ref={this.CAMPAIGNS_DEFAULT} id="campaigns_default">
                            <CarouselCampaignsOldBranding showDefaultImg={true} />
                        </div>
                    </div>
                    }
                    {showOldBranding && !initialData.isStaticHtmlExport && !isOffTheCuffPreview && this.showEvents() &&
                        <div data-entitlement="EVENTS" ref={this.EVENTS}>
                            {/* showUncomingEvent judgement inside CarouselEvents.Because it should add a new action and mapToProps, add in here will cause too much component reRender*/}
                            <CarouselEventsOldBranding />
                        </div>
                    }
                </span >
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        platformIdData: state.asyncStateReducer.platformIdData,
    };
};

export default connect(mapStateToProps)(InfoPane);
